import { usePartnerConfig } from "Hooks/usePartnerConfig";
import colors from "Styles/colors";

export const useDPTheme = () => {
  const { loading, error } = usePartnerConfig();
  const themeSpecificColors = {
    circleArrowBackgroundFill: colors.opaqueTangaroa,
    helpIconColor: colors.midTangaroa,
  };

  if (error) {
    console.error(error);
  }

  return {
    themeSpecificColors,
    loading,
    error,
  };
};
